//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import publicRules from '@/js/rules';
import treetag from "@/pccomponents/TreeTag";
import formValidate from "@/js/formValidate";
  export default {
    name: "userinfopage",
    components: {
      treetag
    },
    data(){
      return {
        formval:{},
        showtree:false,
        areacode:'',
        showDialog:true,
        //控制弹出框显示
        dialogDetailVisible:false,
        //查询条件
        queryinfo: {
          vuserid:"",
          vdeptid:"",
          vusername: "",
          vareaid:""
        },
        //左侧树列表
        treedata:[],
        //右侧表单列表
        tableData:[],
        //详情数据
        record:{
        },
        //左侧树结构
        defaultProps: {
          children: 'children',
          label: 'deptname'
        },
        //部门类型
        depttypelist:[],
        //状态列表
        statusList:[],
        //部门类型
        userdepttypeList:[],
        //删除的行项ID
        delrowids:[

        ],
        //是否锁定
        lockList:[],
        //性别列表
        genderList:[],
        //当前第几页
        currPage: 1,
        //默认页数
        rowsPerPage: 10,
        //总共几条数据
        totalPage: 0,
        //规则校验弹出框的值
        formTipArray:[],
        rules:{
        },
        edititems:"",
        //行项列格式
        row:{
          company:"",
          deptname:"",
          title:"",
          depttype:""
        },
        notNullItems:"",
        deluserid:[],
        flowsysid:'FLOW',
      }
    },
    methods: {
      /**
       * 删除用户
       */
      deleteUser(){
        let deluserids = [];
        for(let user of this.deluserid){
          deluserids.push(user.userid);
        }
        let params = {
          userids: deluserids,
          flowsysid:this.flowsysid,
        }
        if(deluserids.length <=0){
            this.tipWarn(this.$t('common.delnoselected'));
        }
        else{
          let url = "userController/deleteUser";
          if(confirm(this.$t('organize.deleteConfig'))==true){
            //请求后端数据
            axios.post(url, params).then(({ data }) => {
              this.queryList();
            });
          }
        }
      },
      /**
      * 分页记录
      */
      pageChange (item) {
        this.currPage = item.page_index;
        this.rowsPerPage = item.page_limit;
        this.queryList(); //改变页码，重新渲染页面
      },
      //查询右侧列表记录
      queryList(){
        let url = "userController/userlist";
        let params = {
          queryinfo:{
            vdeptid :this.queryinfo.vdeptid,
            v_username :this.queryinfo.vusername
          },
          pageinfo:{
              currPage: this.currPage,
              rowsPerPage: this.rowsPerPage
          },
          flowsysid:this.flowsysid,
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
           this.tableData = data.data.record;
           this.totalPage = data.data.pageinfo.count
           
        });
      },
      // 点击树节点
      clickTree(data) {
        this.queryinfo.vdeptid = data.id;
        if(this.queryinfo.vdeptid != '0'){
          //设置地区ID
          this.queryinfo.vareaid = data.areaid;
          this.queryinfo.vdeptname = "";
          this.queryList();
        }
      },
      /**
       * 新增用户信息
       */
      addUserInfo(){
        this.dialogDetailVisible = true;
        this.showDialog = true;
        let url = "userController/addUserInfo";
        let params = {
          record:{
            vdeptid:this.queryinfo.vdeptid,
          },
          flowsysid:this.flowsysid,
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
          console.log(data);
           this.record = data.data.record;
           //行表绑定变量
           this.$set(this.record,"rowsList",data.data.record.userdeptList);
           //加载必填域
            formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
            this.edititems = data.data.edititems;
            this.notNullItems = data.data.notNullItems;
        });
        this.initSelect(); 
      },
       /**
       * 查看部门信息详情
       */
      modifityDept(index, row){
         // this.tipSuccess(row.deptid);
        this.dialogDetailVisible = true;
        this.showDialog = true;
        let url = "userController/loadUserInfo";
        let params = {
            record:{
              vuserid:row.userid
            },
            flowsysid:this.flowsysid,
        }
        //请求后端数据
        axios.post(url, params).then(({ data }) => {
           console.log(data);
           this.record = data.data.record;
           console.log(this.record);
          // this.record.rowsList = data.data.userDeptList;
          //this.$set() 绑定数据会被VUE所监听
           this.$set(this.record,"rowsList",data.data.userDeptList);
            //加载必填域
            formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
            this.edititems = data.data.edititems;
            this.notNullItems = data.data.notNullItems;
        });
        this.initSelect(); 
     },
      //保存部门信息
      saveuser(){
         let url = "userController/saveUserInfo";
         let params = {
           record : this.record,
           delrows:this.delrowids,
           flowsysid:this.flowsysid,
         };
       console.log(params);
       this.$refs["userform"].validate((valid) => {
         
          // 验证通过
          if (valid) {
            //请求后端数据
              axios.post(url, params).then(({ data }) => {
              //单据获取成功
              if(data.code === '1'){
              this.tipSuccess('保存成功');
                this.queryList();
                this.dialogDetailVisible =false;
              }
                
              }); 
          } else {
            this.formErrorTip("信息错误",this.formTipArray);

            this.formTipArray.length=0
            return false;
          }
      });
      
      },

      /**
       * 点击取消按钮
       */
      changle(){
        this.dialogDetailVisible =false;
        this.showDialog = false;
        this.closeDialog();
      },

      /**
       * 关闭弹出框
       */
      closeDialog(){
        this.showDialog = false;
        this.record = [];
      },
     //调用人员弹出框后返回的参数
     selectUserbak(Obj){
       console.log("==============hello");
       console.info(Obj.returnData);
     },
     /**
      * 部门回调方法
      */
     selectDeptbak(params){
      //行项
      let rowindex = params["rowindex"];
      let returnData = params["returnData"];
      this.$set(this.record.rowsList[rowindex],'deptname',returnData[0].deptname);
      this.$set(this.record.rowsList[rowindex],'deptid',returnData[0].deptid);

      //动态添加行项
      if(returnData && returnData.length >1){
          for(let i = 1 ; i < returnData.length;i++){
              let obj = {};
              obj["deptname"] = returnData[i].deptname;
              obj["deptid"] = returnData[i].deptid;
              this.record.rowsList.push(obj);
          }
      }
     },
     /**
      * 清空行项方法
      */
     clearDeptbak(params){
        let rowindex = params["rowindex"];
        this.$set(this.record.rowsList[rowindex],'deptname','');
        this.$set (this.record.rowsList[rowindex],'deptid','');
    },
     /**
       * 初始化全部下拉框
       */
      initSelect(){
         //初始化下拉框
        let statuparam = {
          showcode:'statusList',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:true,
          paras:{"paras0":"STATUSTYPE","paras1":"1"}
        };
        //锁定状态
        let lockparam= {
          showcode:'lockList',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:true,
          paras:{"paras0":"LOCKTYPE","paras1":"1"}
        };
        //性别
        let genderparam= {
          showcode:'genderList',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:false,
          paras:{"paras0":"GENDER","paras1":"1"}
        };
        let userdepttypparam ={
          showcode:'userdepttypeList',
          selectcode:'SYS_CDFCODECONFIG',
          hasnull:true,
          paras:{"paras0":"USERDEPTTYPE","paras1":"1"}
        };

        let params = [];
        params.push(statuparam);
        params.push(lockparam);
        params.push(genderparam);
        params.push(userdepttypparam);
        this.initDropDown(this,params);
      },
      selectCheck(val){
        this.deluserid =val;
      },
      inituser(){
      let url = "userController/getUserInfo";
      let params = {
  
      }
      //请求后端数据
      axios.post(url, params).then(({ data }) => {
          this.areacode = data.data.position.areacode;
          this.showtree = true;  
      });
    }
    },
    //页面初始化的时候加载树 
    created(){
      this.inituser();
     
    },
    mounted() {
      
      this.setMainContentHeight();
    }
  }



// WEBPACK FOOTER //
// ./src/pcpage/system/organize/userinfo.vue